import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { ContratoService, ProponenteService } from 'administrativo-lib';
import { PrazoService, TipoContratacaoService } from 'compra-lib';
import { Contrato, ContratoRenegociacao, ContratoRenegociacaoItem, EddyAutoComplete, Favorecido, FuncaoService, GlobalService, Login, Prazo, Proponente, Proposta, TipoContratacao, TipoContrato } from 'eddydata-lib';
import { ConfirmationService } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { error, success, warning } from 'toastr';
import { ContratoItemService } from '../service/contrato-item.service';
import { ContratoRenegociacaoService } from '../service/contrato-renegociacao.service';

declare var $: any;

@Component({
  selector: 'app-contrato-renegociacao-dlg',
  templateUrl: './contrato-renegociacao-dlg.component.html',
})
export class ContratoRenegociacaoDlgComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  protected datepipe: DatePipe;
  public ptBR: any;
  protected unsubscribe: Subject<void> = new Subject();
  public manualEditValue = true;
  public temContrato: boolean = true;
  public proponenteAtual: ContratoRenegociacao;
  public apenasQtdeRenegociacao: boolean = false;
  public proponente: Proponente;
  public mostrarBtnIncluirProp: boolean = false;
  public desabilitarBotaoSalvar = false;
  public listaTipos: { id: TipoContrato, nome: string }[];
  public listaContratacao: TipoContratacao[];
  public listaPrazos: Prazo[];
  public tipos: { id: 'CONTRATO' | 'REGISTRO_PRECO' | 'ATA_REGISTRO', nome: string }[];

  public proponenteAutoComplete: EddyAutoComplete<Proponente>;
  public proponenteAuto: Proponente;

  @Input() visualizar_item: boolean;
  @Input() entidade: ContratoRenegociacao;
  @Input() listaRenegociacao: ContratoRenegociacao[] = []
  @Input() lista: Array<any>;
  @Input() login: Login;
  @Input() contrato: Contrato;
  @Output() visualizarChange: EventEmitter<boolean> = new EventEmitter();

  public imaskQtd = {
    mask: Number,
    scale: 4,
    signed: false,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  public imaskQtdNeg = {
    mask: Number,
    scale: 4,
    signed: true,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  imaskConfigValor = {
    mask: Number,
    scale: 4,
    signed: false,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  }

  imaskConfigValorNeg = {
    mask: Number,
    scale: 4,
    signed: true,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  }

  imaskConfig = {
    mask: Number,
    scale: 4,
    signed: false,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  constructor(
    public funcaoService: FuncaoService,
    public renegocicaoService: ContratoRenegociacaoService,
    private globalService: GlobalService,
    private contratoItemService: ContratoItemService,
    private contratoService: ContratoService,
    private confirmationService: ConfirmationService,
    protected contratacaoService: TipoContratacaoService,
    protected prazoService: PrazoService,
    private proponenteService: ProponenteService,

  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['entidade'] && this.entidade?.id && this.entidade.contrato_enviado?.id) {
      this.proponenteAtual = this.entidade;
    }
  }

  ngOnInit() {
    $('#dialogRenegociacao').on('hidden.bs.modal', (e) => {
      this.proponenteAtual = null;
      this.proponenteAuto = null;
    });
    this.ptBR = this.globalService.obterDataBR();
    this.tipos = [{ id: 'CONTRATO', nome: 'Contrato' }, { id: 'REGISTRO_PRECO', nome: 'Registro de Preço' }];
    this.listaTipos = this.globalService.obterTiposContrato();
    this.contratacaoService.filtrar(0, 0, { orgao_id: this.login.orgao.id }).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaContratacao = res ? res.content : [];
      }, error => error(error.message ? error.message : error));
    this.prazoService.filtrar(0, 0, { orgao_id: this.login.orgao.id }).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaPrazos = res ? res.content : [];
      }, error => error(error.message ? error.message : error));
    this.proponenteAutoComplete = new EddyAutoComplete(null, this.proponenteService,
      'favorecido.id', ['favorecido.nome'], { 'licitacao.id': this.contrato.licitacao.id, 'favorecido.id$ne': this.contrato.favorecido.id, relations: 'favorecido,propostas.memorial', orderBy: 'favorecido.nome' }, { number: ['favorecido.id', 'favorecido.cpf_cnpj'], text: ['favorecido.nome'] }
    );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => this.globalService.calendarMascara(), 500);
  }

  public async salvar(): Promise<void> {
    try {
      let listaSalvar: ContratoRenegociacao[] = [];
      this.desabilitarBotaoSalvar = true;

      for (const renegociacao of this.listaRenegociacao) {
        const possuiItensValidos = renegociacao.itens?.some(i => i.quantidade > 0);
        if (!possuiItensValidos) continue;

        const nomeFavorecido = renegociacao.contrato_recebido?.favorecido?.nome || '';

        if (!renegociacao.data_renegociacao) {
          throw new Error(`É necessário informar a data da renegociação: ${nomeFavorecido}.`);
        }
        if (!renegociacao.data_contabilizacao) {
          throw new Error(`Por favor, informe a data de contabilização da renegociação: ${nomeFavorecido}.`);
        }
        if (!renegociacao.motivo) {
          throw new Error(`Por favor, preencha o campo motivo para a renegociação: ${nomeFavorecido}.`);
        }
        if (!this.funcaoService.podeAlterarAudesp(renegociacao.data_contabilizacao, this.login)) {
          throw new Error(`Data de contabilização inválida para a renegociação de ${nomeFavorecido}. O período contábil já está fechado. Entre em contato com o contador.`);
        }

        const dtContabilizacao = new Date(renegociacao.data_contabilizacao);
        if (dtContabilizacao.getFullYear() !== this.login.exercicio.ano) {
          throw new Error(`O ano da data de contabilização da renegociação de ${nomeFavorecido} está diferente do exercício logado.`);
        }

        // Validações do Contrato
        if (!this.temContrato) {
          if (!renegociacao['numero']) {
            throw new Error(`Por favor, informe o número do contrato para a renegociação: ${nomeFavorecido}.`);
          }
          if (!renegociacao['tipo']) {
            throw new Error(`Por favor, selecione o tipo de contrato para a renegociação: ${nomeFavorecido}.`);
          }
          if (!renegociacao['data_assinatura']) {
            throw new Error(`É necessário informar a data de assinatura do contrato para a renegociação: ${nomeFavorecido}.`);
          }
          if (!renegociacao['data_inicio']) {
            throw new Error(`É necessário informar a data de início do contrato para a renegociação: ${nomeFavorecido}.`);
          }
          if (!renegociacao['data_termino']) {
            throw new Error(`É necessário informar a data de término do contrato para a renegociação: ${nomeFavorecido}.`);
          }
          if (!renegociacao['data_contabilizacao_contrato'] && !renegociacao['inativo']) {
            throw new Error(`Para contratos ativos, é obrigatório informar a data de contabilização para a renegociação: ${nomeFavorecido}.`);
          }
          if (!renegociacao['tipo_contratacao']) {
            throw new Error(`Por favor, selecione o tipo de contratação para a renegociação: ${nomeFavorecido}.`);
          }
          if (!renegociacao['prazo']) {
            throw new Error(`Por favor, selecione o prazo de pagamento do contrato para a renegociação: ${nomeFavorecido}.`);
          }
        }


        const camposParaValidar: Array<'quantidade' | 'valor_unitario_recebido'> = ['quantidade', 'valor_unitario_recebido'];
        for (const item of renegociacao.itens) {
          for (const campo of camposParaValidar) {
            this.validarCamposRenegociacao(item, campo);
          }
        }

        renegociacao.itens = renegociacao.itens.filter(i => i.quantidade > 0);
        renegociacao.valor_total_recebido = this.totalizar(renegociacao.itens);
        listaSalvar.push(renegociacao);
      }

      if (!listaSalvar.length) {
        throw new Error(`Não houve nenhuma renegociação realizada para salvar.`);
      }

      await this.renegocicaoService.salvarLista(listaSalvar).toPromise();
      success('Renegociação inserida com sucesso!');
      $('#dialogRenegociacao').modal('hide');
      this.visualizarChange.emit(true);
      this.desabilitarBotaoSalvar = false;
    } catch (e) {
      this.desabilitarBotaoSalvar = false;
      this.funcaoService.acaoErro(e);
    }
  }


  compareFn(c1: any, c2: any): boolean {
    if (c1 && c2) {
      if (c1.id && c2.id) {
        return c1.id === c2.id;
      } else if (c1.chave && c2.chave) {
        return c1.chave == c2.chave;
      } else {
        return c1 === c2;
      }
    } else {
      return false;
    }
  }

  public onFocusDate() {
    this.globalService.calendarMascara();
  }

  public visualizarItem(visualizar_item) {
    if (visualizar_item === true) {
      return true
    } else {
      return false
    }
  }

  public toggleManualEdit(): void {
    this.manualEditValue = !this.manualEditValue;
  }

  public async carregarRenegocicao() {

    if (this.proponenteAtual && this.proponenteAtual?.contrato_recebido?.favorecido?.id) {
      let possuiContrato = await this.contratoService.obter({
        'licitacao.id': this.contrato.licitacao.id,
        'favorecido.id': this.proponenteAtual?.contrato_recebido?.favorecido?.id,
        'orgao.id': this.login.orgao.id,
        inativo: false, excluido: false,
        /*relations: 'itens.produto_unidade.produto,itens.produto_unidade.unidade'*/
      }).toPromise();
      this.temContrato = true;
      if (possuiContrato?.id) {
        this.proponenteAtual.contrato_recebido = possuiContrato;
      } else {
        this.temContrato = false;
        this.proponenteAtual['tipo'] = this.contrato.tipo;
        this.proponenteAtual['tipo_contratacao'] = this.contrato.tipo_contratacao;
        this.proponenteAtual['tipo_contrato'] = this.contrato.tipo_contrato;
        this.proponenteAtual['ano'] = new Date().getFullYear();
        this.proponenteAtual['modalidade'] = this.contrato.modalidade;
        this.proponenteAtual['inativo'] = this.login.parametro['licitacao']?.contratos_inativos;
        this.proponenteAtual['numero'] = await this.contratoService.proximoNumero(this.login.exercicio.ano, this.login.orgao.id).toPromise();
        this.proponenteAtual['objeto'] = this.contrato.objeto;
      }
    }
    this.converterRenegociacao()
  }

  public converterRenegociacao() {
    this.proponenteAtual?.itens?.forEach((prop) => {
      const itemDaEntidade = this.proponenteAtual?.contrato_enviado?.itens.find(i => i.id === prop.contrato_enviado_item.id);
      if (itemDaEntidade) {
        let quantidadeAtual = itemDaEntidade['saldo_qtd'];
        this.listaRenegociacao.forEach(renegociacao => {
          const quantidadeRenegociada = renegociacao?.itens?.reduce((acc, atual) => {
            if (atual.contrato_enviado_item.id === itemDaEntidade.id) {
              return acc + (+atual.quantidade);
            }
            return acc;
          }, 0);

          if (quantidadeRenegociada > 0) {
            quantidadeAtual -= quantidadeRenegociada;
          }
        });
        if (!prop?.quantidade) {
          prop.saldo = quantidadeAtual;
        }
      }
    });
  }

  public totalizar(itens: ContratoRenegociacaoItem[]) {
    return this.funcaoService.arredondar(itens.reduce((acumulador, item) => (item.quantidade * item.valor_unitario_recebido) + acumulador, 0), 4)
  }

  public validarCamposRenegociacao(item: ContratoRenegociacaoItem, campo: 'valor_unitario_recebido' | 'quantidade'): void {
    const descricaoItem = item?.contrato_enviado_item?.descricao || 'desconhecido';

    if (item.quantidade < 0 && campo === 'quantidade') {
      throw new Error(`Por favor, informe a quantidade para o item: ${descricaoItem}.`);
    }

    if (item.valor_unitario_recebido <= 0 && item.quantidade > 0 && campo === 'valor_unitario_recebido') {
      throw new Error(`Por favor, informe o valor unitário para o item: ${descricaoItem}.`);
    }

    if (item.quantidade > item.saldo && item.valor_unitario_recebido) {
      item.quantidade = 0;
      throw new Error(`A quantidade informada para o item ${descricaoItem} é maior do que a prevista no item do contrato.`);
    }

    const itemDoContrato = this.contrato?.itens?.find(i => i.id === item.contrato_enviado_item?.id);

    if (itemDoContrato) {
      let quantidadeRenegociada = 0;

      this.listaRenegociacao.forEach(renegociacao => {
        const somaRenegociacao = renegociacao?.itens?.reduce((acc, atual) => {
          if (atual.contrato_enviado_item?.id === itemDoContrato.id) {
            return acc + (+atual.quantidade);
          }
          return acc;
        }, 0);
        quantidadeRenegociada += somaRenegociacao || 0;
      });

      if (quantidadeRenegociada > itemDoContrato['saldo_qtd']) {
        item.quantidade = 0;
        throw new Error(`A quantidade informada para o item ${itemDoContrato.descricao} é maior do que a prevista no item do contrato.`);
      }
    }
  }

  public validarBlur(item: ContratoRenegociacaoItem, campo: 'valor_unitario_recebido' | 'quantidade'): void {
    try {
      this.validarCamposRenegociacao(item, campo);
    } catch (e) {
      this.funcaoService.acaoErro(e);
    }
  }

  selecionarProponente(proponenteSelecionado: Proponente) {
    this.listaRenegociacao = []
    this.proponenteAtual = {
      data_renegociacao: this.funcaoService.obterDataUTC(new Date()),
      data_contabilizacao: this.funcaoService.obterDataUTC(new Date()),
      contrato_enviado: this.contrato,
      usuario: this.login.usuario,
      exercicio: this.login.exercicio,
      contrato_recebido: {
        favorecido: proponenteSelecionado.favorecido
      },
      editavel: true,
      valor_total_enviado: 0,
      valor_total_recebido: 0,
      itens: this.contrato.itens.map(item => ({
        quantidade: 0,
        saldo: item['saldo_qtd'],
        valor_unitario_enviado: item.vl_unit_atualizado > 0 ? item.vl_unit_atualizado : item.valor_unitario,
        valor_unitario_recebido: proponenteSelecionado.propostas.find(
          (p) => p?.memorial && item?.memorial && p.memorial?.id === item.memorial?.id
        )?.valor_unitario ?? 0,
        contrato_enviado_item: item
      }))
    }

    this.listaRenegociacao.push(this.proponenteAtual);

    this.carregarRenegocicao();
  }
}
